import * as actionTypes from '../actions/modals/types';

const initialState = {
    ticket_comment_modal: {isOpen: false, isReply: false, ticket: null, parent: null},
    ticket_takeover_modal: {isOpen: false, ticket: null},
};

const modalsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OPEN_TICKET_COMMENT_MODAL: {
            const {ticket, isReply, parent} = action.payload;

            return {...state, ticket_comment_modal: {isOpen: true, ticket, isReply, parent}};
        }

        case actionTypes.CLOSE_TICKET_COMMENT_MODAL: {
            return {...state, ticket_comment_modal: initialState.ticket_comment_modal};
        }

        case actionTypes.OPEN_TICKET_TAKEOVER_MODAL: {
            const {ticket} = action.payload;

            return {...state, ticket_takeover_modal: {isOpen: true, ticket}};
        }

        case actionTypes.CLOSE_TICKET_TAKEOVER_MODAL: {
            return {...state, ticket_takeover_modal: {isOpen: false, ticket: null}};
        }

        default:
            return state;
    }
}

export default modalsReducer;
